import UibookCase from 'uibook/case'
import React from 'react'
import TelegramBadge from '../TelegramBadge'

const I18N = {
  ru: {
    number: 'Числовой бейдж',
    numberLarge: 'Крупный числовой бейдж',
    dot: 'Dot бейдж',
    dotCritical: 'Dot critical',
    hintNumber: 'Компактный числовой формат.',
    hintLarge: 'Увеличенный бейдж для важного статуса.',
    hintDot: 'Точечный индикатор без числа.',
    hintDotCritical: 'Критический точечный индикатор.',
  },
  en: {
    number: 'Numeric badge',
    numberLarge: 'Large numeric badge',
    dot: 'Dot badge',
    dotCritical: 'Critical dot',
    hintNumber: 'Compact numeric format.',
    hintLarge: 'Large badge for important state.',
    hintDot: 'Dot indicator without number.',
    hintDotCritical: 'Critical dot indicator.',
  }
}

export default {
  background: 'light',
  component: TelegramBadge,
  i18n: true,
  cases: [
    locale => <UibookCase props={{ type: 'number', mode: 'primary', value: '3', label: I18N[locale].number, description: I18N.en.hintNumber }}></UibookCase>,
    locale => <UibookCase props={{ type: 'number', mode: 'secondary', large: true, value: '24', label: I18N[locale].numberLarge, description: I18N.en.hintLarge }}></UibookCase>,
    locale => <UibookCase props={{ type: 'dot', mode: 'gray', label: I18N[locale].dot, description: I18N.en.hintDot }}></UibookCase>,
    locale => <UibookCase props={{ type: 'dot', mode: 'critical', label: I18N[locale].dotCritical, description: I18N.en.hintDotCritical }}></UibookCase>
  ]
}
